import { useMutation } from '@tanstack/react-query'

import { APIInstance } from '@/utils/functions/instance'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

import { ICreateCategoryParamsType } from './type'

export function useCreateCategory({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<ICreateCategoryParamsType> = {}) {
  return useMutation({
    mutationFn: async () =>
      await APIInstance<IResponseType<[]>>({
        url: 'mrf/categories-register/',
        method: 'post',
        data
      }),
    retry: 0,
    mutationKey: ['createCategory', data],
    ...rest
  })
}
